import React from 'react';

import AboutUs from './Main/AboutUs';
import WhyUs from './Main/WhyUs';
import Menu from './Main/Menu';
import Specials from './Main/Specials';
import Events from './Main/Events';
import BookATable from './Main/BookATable';
import Testimonials from './Main/Testimonials';
import Galery from './Main/Galery';
import Chefs from './Main/Chefs';
import Contact from './Main/Contact';



function Main() {
    return (
    <main id="main">
          
        <AboutUs/>
        <WhyUs/>
        <Menu/>
        <Specials/>
        <Testimonials/>         
        <BookATable/>
        <Chefs/>
        <Events/>
        <div className="baniere"></div>
        <Contact/>   
        <Galery/>
     
    
  
   </main>
    )
}

export default Main
